import { AuthPartialStoreState } from '../auth.reducer';

export const getCallback = (state: AuthPartialStoreState) => state.auth.authParameters.callback;
